import { useDispatch, useSelector } from 'hooks/utils';
import { SetSetRevisionIdAction, setSetRevisionId } from 'store/data/revisions';
import { LocalOperationResult } from 'hooks/store/types';
import { ActionPayload } from 'store/types';

type Data = string | null;
type Handler = (revisionId: ActionPayload<SetSetRevisionIdAction>['revisionId']) => void;

export function useSetRevisionId(): LocalOperationResult<Data, Handler> {
	const dispatch = useDispatch();

	const data = useSelector(state => state.data.revisions.metadata.setRevisionId);

	function handler(revisionId: ActionPayload<SetSetRevisionIdAction>['revisionId']) {
		dispatch(setSetRevisionId({ revisionId }));
	}

	return [data, handler];
}
